import React from 'react';
import PropTypes from 'prop-types';

import FavoriteIcon from '@icons/FavoriteIcon';
import ShareIcon from '@icons/ShareIcon';

// eslint-disable-next-line import/no-cycle
import MailIcon from '../../icons/MailIcon';
import useAuthorized from '@hooks/useAuthorized';

const BaseListItem = ({
    id,
    graphID,
    type,
    title,
    url,
    showMailIcon = false,
    showFavoriteIcon = true,
    showShareIcon = true,
    isFavorite,
    imageBlock,
    contentBlock,
    onFavorite,
    onMessage,
    isLoadingFavorite,
}) => {
    const { isLoggedIn } = useAuthorized();

    const renderIcons = () => (
        <div className="d-flex align-items-center">
            {showMailIcon && (
                <div className="mr-2">
                    <MailIcon id={id} graphID={graphID} isLoggedIn={isLoggedIn} onMessage={onMessage} />
                </div>
            )}

            {showShareIcon && (
                <div className="mr-1rem">
                    <ShareIcon title={title} url={url} />
                </div>
            )}

            {showFavoriteIcon && (
                <FavoriteIcon
                    id={id}
                    type={type}
                    isFavorite={isFavorite}
                    onClick={onFavorite}
                    isLoading={isLoadingFavorite}
                />
            )}
        </div>
    );

    return (
        <div className="list-card py-4 px-2 px-md-0 my-0 w-100">
            <div className="d-flex">
                {imageBlock && <div className="my-0 pt-1">{imageBlock}</div>}

                <div className="d-flex w-100">
                    <div className="card-block m-0 ml-md-3 p-0 pl-2 pl-sm-0 pl-md-2">{contentBlock}</div>
                    <div>{renderIcons()}</div>
                </div>
            </div>
        </div>
    );
};

BaseListItem.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    graphID: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
    showMailIcon: PropTypes.bool,
    showFavoriteIcon: PropTypes.bool,
    showShareIcon: PropTypes.bool,
    isFavorite: PropTypes.bool,
    imageBlock: PropTypes.any,
    contentBlock: PropTypes.any,
    onFavorite: PropTypes.func,
    onMessage: PropTypes.func,
    isLoadingFavorite: PropTypes.bool,
};

export default BaseListItem;
